import { Stack } from '@mui/material';
import OwnerFilterChip from './OwnerFilterChip';
import GeneralTableFilters from './GeneralTableFilters';
import GeneralCount from './GeneralCount';
import MarketplaceFiltersChip from './MarketplaceFiltersChip';

export default function Toolbar({ count }) {
	return (
		<Stack spacing={2}>
			<Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
				{count >= 0 && <GeneralCount count={count} />}

				<GeneralTableFilters />
			</Stack>

			<Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
				<MarketplaceFiltersChip />
				<OwnerFilterChip />
			</Stack>
		</Stack>
	);
}
